import React, { useEffect, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة خطر الإصابة بمرض السكري";
const DESCRIPTION =
  "حاسبة خطر السكري الدقيقة: اكتشف احتمال إصابتك بمرض السكري خلال 7.5 سنوات بناءً على العمر، الوزن، التاريخ العائلي، ونمط الحياة! أداة معتمدة طبياً مع نصائح وقائية لتقليل المخاطر - خاصة لمرحلة ما قبل السكري.";
const KEYWORDS =
  "حاسبة السكري, خطر السكري, مؤشر كتلة الجسم, مستوى السكر في الدم, الكوليسترول";
const OG_URL =
  "https://do-calculate.com/calculator/ar/diabetes-risk-calculator/";
function DiabetesRiskCalculator() {
  const [age, setAge] = useState(0);
  const [sex, setSex] = useState(1);
  const [ethnicity, setEthnicity] = useState(1);
  const [physicalActivity, setPhysicalActivity] = useState(1);
  const [height, setHeight] = useState(0);
  const [weight, setWeight] = useState(0);
  const [bmi, setBMI] = useState(0);
  const [familyHistory, setFamilyHistory] = useState(1);
  const [highBloodPressure, setHighBloodPressure] = useState(0);
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    if (height > 0 && weight > 0) {
      const heightInMeters = height / 100;
      const calculatedBMI = weight / (heightInMeters * heightInMeters);
      setBMI(calculatedBMI.toFixed(1));
    }
  }, [height, weight]);
  const calculateRiskScore = () => {
    let score = 0;
    score += parseInt(familyHistory, 10);
    score += parseInt(highBloodPressure, 10);
    const ageNum = parseInt(age, 10);
    if (ageNum >= 60) {
      score += 3;
    } else if (ageNum >= 50) {
      score += 2;
    } else if (ageNum >= 40) {
      score += 1;
    }
    if (parseInt(ethnicity, 10) === 1) {
      score += 1;
    }
    if (parseInt(physicalActivity, 10) === 0) {
      score += 1;
    }
    score += parseInt(sex, 10);
    const bmiNum = parseFloat(bmi);
    if (bmiNum >= 40) {
      score += 3;
    } else if (bmiNum >= 30) {
      score += 2;
    } else if (bmiNum >= 25) {
      score += 1;
    }
    return score;
  };
  const handleCalculate = () => {
    try {
      const score = calculateRiskScore();
      const riskMessage =
        score >= 5
          ? `النسبة: ${score} - أنت في خطر مرتفع للإصابة بمقدمات السكري.`
          : `النسبة: ${score} - أنت في خطر منخفض للإصابة بمقدمات السكري.`;
      setResult(`${riskMessage} بناءً على العوامل التي قدمتها.
        حيث أنه إذا كانت النسبة أقل من 5 تعتبر في خطر منخفض! `);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  احسب مخاطر الإصابة بالسكري في 7.5 سنوات بدقة باستخدام حاسبتنا
                  الشاملة! باستخدام هذه الأداة المتطورة، يمكنك تقييم احتمالية
                  إصابتك بالسكري في المستقبل القريب من خلال إدخال معلومات صحية
                  أساسية مثل العمر، الجنس، الطول، العرق، التاريخ العائلي، مستوى
                  النشاط البدني، ضغط الدم، مؤشر كتلة الجسم (BMI).
                </p>
                <p>
                  لماذا يجب عليك استخدام حاسبة مخاطر الإصابة بالسكري؟ معرفة
                  مخاطر الإصابة بالسكري يمكن أن يساعدك على اتخاذ خطوات استباقية
                  للحفاظ على صحتك والوقاية من هذا المرض المزمن. من خلال فهم
                  احتمالية إصابتك بالسكري، يمكنك إجراء تغييرات صحية في نمط
                  حياتك، مثل اتباع نظام غذائي متوازن، ممارسة الرياضة بانتظام،
                  والتحكم في الوزن، لتقليل مخاطر الإصابة بالسكري.
                </p>
                <p>
                  تم جمع النقاط لكل عامل خطر أدناه لحساب النتيجة النهائية. على
                  سبيل المثال، إذا أجبت "نعم" على السؤال "هل يوجد لديك أم أو أب
                  أو أخ أو أخت مصاب بالسكري؟"، فإنك تحصل على نقطة واحدة تحت
                  عنوان "التاريخ العائلي". وإذا أجبت "لا" على السؤال "هل تم
                  تشخيص إصابتك بارتفاع ضغط الدم؟"، فإنك تحصل على 0 نقطة تحت
                  عنوان "ارتفاع ضغط الدم"، وهكذا بالنسبة لجميع عوامل الخطر.
                  يعتبر إجمالي 5 نقاط أو أكثر مؤشراً على ارتفاع خطر الإصابة
                  بالمرحلة السابقة للسكري (prediabetes).
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">العمر</label>
                      <input
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="أدخل عمرك"
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="sex">الجنس</label>
                      <select
                        id="sex"
                        value={sex}
                        onChange={(e) => setSex(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>ذكر</option>
                        <option value={0}>أنثى</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="ethnicity">العرق</label>
                      <select
                        id="ethnicity"
                        value={ethnicity}
                        onChange={(e) => setEthnicity(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>
                          أمريكي لاتيني أو من أصول أفريقية أو آسيوية
                        </option>
                        <option value={0}>أبيض غير إسباني</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="physicalActivity">
                        مستوى النشاط البدني
                      </label>
                      <select
                        id="physicalActivity"
                        value={physicalActivity}
                        onChange={(e) => setPhysicalActivity(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>نشيط</option>
                        <option value={0}>غير نشيط</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="bloodPressure">
                        هل ضغط الدم مرتفع لديك؟
                      </label>
                      <select
                        id="bloodPressure"
                        value={highBloodPressure}
                        onChange={(e) => setHighBloodPressure(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>نعم</option>
                        <option value={0}>لا</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">الطول (سم)</label>
                      <input
                        type="number"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        placeholder="أدخل طولك (بالسنتيمترات)"
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">الوزن (كجم)</label>
                      <input
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="أدخل وزنك (بالكيلوغرام)"
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="bmi">
                        مؤشر كتلة الجسم (BMI)
                      </label>
                      <input
                        id="bmi"
                        type="text"
                        value={bmi}
                        readOnly
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="familyHistory">
                        التاريخ العائلي لمرض السكري
                      </label>
                      <select
                        id="familyHistory"
                        value={familyHistory}
                        onChange={(e) => setFamilyHistory(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>يوجد تاريخ عائلي</option>
                        <option value={0}>لا يوجد تاريخ عائلي</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النسبة المئوية لخطر الإصابة:</h4>
                      <p className="text-white">{result}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">حساب مخاطر الإصابة بالسكري</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مقدمة</h2>{" "}
                  </u>
                  <p>
                    حساب مخاطر الإصابة بالسكري يساعد في تحديد مستوى خطر الإصابة
                    بمرض السكري بناءً على مجموعة من العوامل الشخصية والطبية.
                  </p>
                  <p>
                    تشمل هذه العوامل العمر، الجنس، العرق، مستوى النشاط البدني،
                    ضغط الدم، الطول، الوزن، والتاريخ العائلي لمرض السكري.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    مثال: يمكن أن يكون العمر فوق 45 عامًا، مع وجود تاريخ عائلي
                    للإصابة بالسكري.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيف يتم حساب النقاط؟</h2>{" "}
                  </u>
                  <p>
                    يتم حساب النقاط بناءً على إدخال المستخدم للمعلومات التالية:
                  </p>
                  <ul>
                    <li>العمر (مثلًا، فوق 45 سنة يمكن أن يعطي 2 نقطة)</li>
                    <li>الجنس (الرجال قد يكون لديهم خطر أعلى)</li>
                    <li>
                      العرق (بعض الأعراق تكون معرضة بشكل أكبر لخطر الإصابة)
                    </li>
                    <li>مستوى النشاط البدني (قلة النشاط تزيد من النقاط)</li>
                    <li>ضغط الدم (الضغط المرتفع يزيد من النقاط)</li>
                    <li>الطول والوزن (لحساب مؤشر كتلة الجسم BMI)</li>
                    <li>
                      التاريخ العائلي مع مرض السكري (وجود تاريخ عائلي يزيد
                      النقاط)
                    </li>
                  </ul>
                  <p>
                    إذا تجاوزت النقاط 5، فهذا يعني وجود خطر مرتفع للإصابة
                    بالسكري.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: شخص لديه 6 نقاط يعني خطر مرتفع.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نصائح للوقاية</h2>{" "}
                  </u>
                  <p>
                    للحفاظ على مستوى سكر الدم في النطاق الطبيعي، يُنصح باتباع
                    نظام غذائي صحي وزيادة النشاط البدني.
                  </p>
                  <ul>
                    <li>تجنب الأطعمة الغنية بالسكر والدهون.</li>
                    <li>ممارسة الرياضة بانتظام.</li>
                    <li>الحفاظ على وزن صحي.</li>
                  </ul>
                  <p>
                    كما يُنصح بإجراء فحوصات دورية لمراقبة مستويات سكر الدم وضغط
                    الدم.
                  </p>
                  <b>مثال: ممارسة رياضة المشي لمدة 30 دقيقة يومياً.</b>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: تناول وجبات متوازنة من الخضروات والبروتين.
                  </div>
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسئلة الشائعة</h2>{" "}
                  </u>
                  <p>
                    هنا تجد إجابات لبعض الأسئلة الشائعة حول حساب مخاطر الإصابة
                    بالسكري.
                  </p>
                  <b>مثال: ما هي عوامل الخطر الأكثر شيوعًا؟</b>
                  <div className="p-3 mb-2 bg-info text-black">
                    عوامل مثل العمر، السمنة، والتاريخ العائلي.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default DiabetesRiskCalculator;
